module.exports = __webpack_public_path__ + "img/document.05bee870.jpg";